import { Link } from 'react-router-dom';
import { useLocale } from '../../context/LocaleContext';

export const company = {
  name: 'United Systema QFZ LLC',
  product: 'Ticketaty',
  address: 'Qatar Free Zone',
  site: 'https://www.united-systema.com',
  siteLabel: 'www.united-systema.com',
  phone: '+974 77363006',
};

export default function LegalPage({ title, intro, children }) {
  const { t, lang } = useLocale();
  const address = lang === 'ar' ? 'منطقة قطر الحرة' : company.address;
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <p className="text-sm font-medium text-purple-700">{company.product}</p>
      <h1 className="mt-2 text-3xl font-medium text-gray-900 tracking-tight">{title}</h1>
      <p className="mt-2 text-sm text-gray-500">{t('operatedBy', { name: company.name, address })}</p>
      <p className="mt-3 text-sm text-gray-500">{t('lastUpdated')}</p>
      <p className="mt-4 text-sm text-gray-600 leading-relaxed">{intro}</p>

      <div className="mt-6 flex flex-wrap gap-2 text-sm">
        <Link to="/terms" className="nav-link px-3 py-1.5 rounded-full border border-[#f3f2f6] bg-white text-gray-700 hover:text-purple-700">{t('customerTerms')}</Link>
        <Link to="/privacy" className="nav-link px-3 py-1.5 rounded-full border border-[#f3f2f6] bg-white text-gray-700 hover:text-purple-700">{t('privacy')}</Link>
      </div>

      <article className="auth-card mt-8 px-6 py-8 sm:px-10 space-y-8 text-sm text-gray-600 leading-relaxed">
        {children}
      </article>
    </div>
  );
}

export function LegalSection({ id, title, children }) {
  return (
    <section id={id}>
      <h2 className="text-lg font-medium text-gray-900 mb-2">{title}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
